<template>
  <div v-loading="initLoading">
    <div class="ReportDetailPagePurchase" style="padding: 20px;width: 500px;background-color: #fafafa">
      <div style="font-size: 20px">
        <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
          <el-breadcrumb-item :to="{ path: '/console' }">数据中心</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/OrangevImport' }">导出数据</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div style="font-size: 25px;margin-top: 15px;">
        <p>导出数据</p>
      </div>

      <div style="width: 100%; font-size: 25px">
        <el-form :model="data" :rules="rules" ref="ruleForm" label-width="100px"
                 style="margin-top: 10px;width: 500px">
          <el-form-item label="时间范围" prop="dateRange">
            <el-date-picker
              v-model="data.dateRange"
              type="monthrange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
              style="width: 400px">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="导出类型" prop="type">
            <el-select v-model="data.type" clearable placeholder="选择类型"
                       style="width: 400px">
              <el-option
                v-for="item in types"
                :key="item.type"
                :label="item.name"
                :value='item.type'>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button class="button" @click="download()" :loading="loading">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>


import {importData} from "@/api/OrangevImport";

export default {
  name: 'LoginSaleAccount',
  data() {
    return {
      loading: false,
      rules: {
        type: [
          {required: true, message: '请选择导出类型', trigger: 'change'}
        ],
        dateRange: [
          {type: 'array', required: true, message: '请选择日期', trigger: 'change'}
        ]
      },
      types: [
        {
          type: 1,
          name: '新增门店指标'
        },
        {
          type: 2,
          name: '大单预警指标'
        },
        {
          type: 3,
          name: '数据魔方使用指标'
        },
        {
          type: 4,
          name: '连锁指标'
        },
        {
          type: 5,
          name: '导购指标'
        },
        {
          type: 6,
          name: '产品品类指标'
        }
      ],
      data: {
        type: null,
        dateRange: null
      },

      pickerOptions: {
        onPick: ({maxDate, minDate}) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = ''
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== '') {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      }
    }
  },
  mounted() {
    this.token = localStorage.getItem('token')
  }
  ,
  methods: {
    download() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.loading = true;
          importData(this.token, this.data).then(res => {
            this.handleDownload(res);

            this.$notify.success({
              title: '成功',
              message: '导出成功',
              position: 'bottom-right'
            })
          }).catch(() => {
            this.$notify.error({
              title: '失败',
              message: '导出失败',
              position: 'bottom-right'
            })
          }).finally(() => {
            this.loading = false;
          })
        }
      });
    }
    ,
    handleDownload(res) {
      let blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      const fileName = decodeURI(res.headers['filename'])
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    }
  }
}
</script>

<style scoped>
.el-select .el-input.is-focus .el-input__inner {
  border-color: #EF6C00;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  color: #EF6C00
}

.el-select .el-select-dropdown__list {
  list-style: none;
  padding: 0px 0;
  margin: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.descriptions {
  line-height: 25px;
  font-size: 10px;
  color: #ED7043;
}

.button {
  color: white !important;
  background: #ff6633 !important;
}
</style>
